module.exports = __webpack_public_path__ + "img/flex.b00effa5.png";